

































import Vue from 'vue'

import {
  IItemReference,
  ILinkedItemForListing,
} from '@/api/types/response.types'

export default Vue.extend({
  name: 'LinkConversationsDrawer',

  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    currentlyLinkedConversations: {
      type: Array as () => ILinkedItemForListing[],
      required: true,
    },
    originatingTask: {
      type: Object as () => IItemReference,
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
      closeDrawerOnOutsideClick: true,
      drawerOpened: false,
    }
  },

  computed: {
    visible: {
      get(): Boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        this.$emit('update:showDrawer', newValue)
      },
    },
    drawerWidthPct(): string {
      if (this.$screen.isMobile(this.$mq)) {
        return '100%'
      }
      return '524px'
    },
  },

  methods: {
    onOpened() {
      this.drawerOpened = true
    },

    onClosed() {
      this.drawerOpened = false
    },

    handleCancel() {
      this.$emit('update:showDrawer', false)
    },
  },
})
